"use strict";
/* istanbul ignore file */
Object.defineProperty(exports, "__esModule", { value: true });
exports.media = void 0;
const constants_1 = require("./constants");
const generateMediaQuery_1 = require("./generateMediaQuery");
exports.media = {
    phone: (options) => (0, generateMediaQuery_1.generateMediaQuery)(constants_1.Breakpoint.PHONE, options),
    tablet: (options) => (0, generateMediaQuery_1.generateMediaQuery)(constants_1.Breakpoint.TABLET, options),
    desktop: (options) => (0, generateMediaQuery_1.generateMediaQuery)(constants_1.Breakpoint.DESKTOP, options),
    wide: (options) => (0, generateMediaQuery_1.generateMediaQuery)(constants_1.Breakpoint.WIDE, options),
};
//# sourceMappingURL=media.js.map